// extracted by mini-css-extract-plugin
module.exports = {"certified-body":"styles_certified-body__1C2BA","certified-body--contents":"styles_certified-body--contents__3Yntl"};